module.exports = __webpack_public_path__ + "img/teachers.5137340a.svg";